import { IApplicationState } from '../../types/redux';
import { selectComparePageType } from './selectComparePageType';
import { selectIds } from '../ids';
import { selectNewbuildingsCompareBlocks } from '../newbuildingsCompare';

export function selectIsCompareEmpty(state: IApplicationState): boolean {
  if (selectComparePageType(state) === 'newbuildings') {
    const summaryRow = selectNewbuildingsCompareBlocks(state)
      .flatMap(block => block.rows)
      .find(row => row.type === 'newbuildingSummary');

    return (summaryRow?.cells.length ?? 0) === 0;
  }

  return selectIds(state).length === 0;
}
